module.exports = __webpack_public_path__ + "static/media/award_black.7d4612a6.svg";